import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseContract } from './base';

export class ApiContractInvoice extends ApiBaseContract {
  @ApiOptions({ channel: 'invoice.get' })
  getInvoice(id: number, params: ParamsAdapter = new DefaultParams()) {
    return this.get(`/invoice/${id}`, params);
  }

  @ApiOptions({ channel: 'invoice.validate' })
  validateInvoice(id: number, interceptErrors: boolean = true) {
    this.options.interceptErrors = interceptErrors;
    return this.post(`/invoice/${id}/validate`);
  }

  @ApiOptions({ channel: 'invoice.publish', requestType: 'json' })
  publishInvoice(id: number, params: ParamsAdapter, interceptErrors: boolean = true) {
    this.options.interceptErrors = interceptErrors;
    return this.post(`/invoice/${id}/publish`, params);
  }

  @ApiOptions({ channel: 'invoice.post', requestType: 'json' })
  alterInvoice(id: number, params: ParamsAdapter) {
    return this.post(`/invoice/${id}/alter`, params);
  }

  @ApiOptions({ channel: 'invoice.unpublish', requestType: 'json', interceptErrors: false })
  unpublishInvoice(invoiceId: number) {
    return this.post(`/invoice/${invoiceId}/unpublish`);
  }

  @ApiOptions({ channel: 'invoice.unvalidate', requestType: 'json' })
  unvalidateInvoice(invoiceId: number, params: ParamsAdapter, interceptErrors: boolean = true) {
    this.options.interceptErrors = interceptErrors;
    return this.post(`/invoice/${invoiceId}/unvalidate`, params);
  }

  @ApiOptions({ channel: 'invoice.pdf', responseType: 'blob' })
  getInvoicePdf(id: number) {
    return this.get<Blob>(`/invoice/${id}/pdf`);
  }

  /**
   * get the invoices as a zip file.
   */
  @ApiOptions({ channel: 'invoice.zip', responseType: 'blob' })
  getInvoicesAsZip(params: ParamsAdapter) {
    return this.post<Blob>(`/invoice/zip`, params);
  }

  /**
   * get the invoices as a Excel file.
   */
  @ApiOptions({ channel: 'invoice.excel', responseType: 'blob' })
  getInvoicesAsExcel(params: ParamsAdapter) {
    return this.get<Blob>(`/invoice/excel`, params);
  }

  @ApiOptions({ channel: 'invoice.get', interceptErrors: false })
  getInternalCode(params: ParamsAdapter) {
    return this.get(`/invoice/internal_code`, params);
  }

  @ApiOptions({ channel: 'invoice.delete', interceptErrors: false })
  deleteRegularizationById(idRegularization: string) {
    return this.delete(`/invoice/regularization/${idRegularization}`);
  }

  @ApiOptions({ channel: 'invoice.delete' })
  deleteRegularizationByContractIdAndMonthAndCountry(params: ParamsAdapter) {
    return this.delete(`/invoice/regularization/multi`, params);
  }

  @ApiOptions({ channel: 'deliveryPointBillingData.get' })
  getDeliveryPointBillingData(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/invoice/data-points/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'deliveryPointBillingData.put' })
  putDeliveryPointBillingData(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/invoice/data-points/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'sapBePrice', responseType: 'blob' })
  getSapPriceFile(params: ParamsAdapter) {
    return this.get<Blob>(`/invoice/sap/excel`, params);
  }
}
